export class FileModel {
  public Attachement: string;
  public MimeType: string;
  public AttachementName: string;

  constructor() {
    this.Attachement = null;
    this.MimeType = null;
    this.AttachementName = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-payor-detail/rider-payor-detail.models.ts